import React, { FC } from "react"
import { Box, BoxProps } from "@chakra-ui/react"

export const NEXT_BUTTON_CONTAINER_HEIGHT = 88

export const NextButtonDefaultContainer: FC<BoxProps> = (props) => (
  <Box paddingX={6} paddingY={4} {...props} />
)
